webpackJsonp([53569954864128],{

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _config = __webpack_require__(10);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _PageTitle = __webpack_require__(22);
	
	var _PageTitle2 = _interopRequireDefault(_PageTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Schedule = function Schedule() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_PageTitle2.default, { title: 'Schedule' }),
	    _react2.default.createElement(
	      'h4',
	      {
	        style: {
	          textDecoration: 'underline'
	        } },
	      _config2.default.wedding.date
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        'strong',
	        null,
	        _config2.default.wedding.startTime + ' - ' + _config2.default.wedding.endTime
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'span',
	        {
	          style: {
	            fontStyle: 'italic'
	          } },
	        'Wedding'
	      ),
	      _react2.default.createElement('br', null),
	      _config2.default.venue.title,
	      _react2.default.createElement('br', null),
	      '(Please arrive no later than ',
	      _config2.default.wedding.arrivalTime,
	      ')'
	    )
	  );
	};
	
	exports.default = Schedule;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-schedule-js-2f56eae060204527c18a.js